const generalInfoStep = {
  name: 'capGeneralInfo',
  text: 'Name your policy, and add a short description.',
  showReset: false,
};

const applicationAssignmentStep = {
  name: 'applicationAssignment',
  text: 'Apply this policy to all applications, or select applications.',
};
const userAssignmentStep = {
  name: 'userAssignment',
  text: 'Apply this policy to all users, or select user groups.',
};
const actionStep = {
  name: 'action',
  text: 'Choose how you want your policy to affect user authentication',
};
const saveStep = {
  name: 'asideSave',
  text: 'You\'re done! Save and apply your policy now!',
  showNext: false,
};

const conditionStepText = {
  device: 'The device condition has been set. Choose whether to apply this policy to JumpCloud managed device or unmanaged devices. You may add additional conditions.',
  locations: 'The locations condition has been set. Select an Operator, and choose which countries you want impacted by this policy. You may add additional conditions.',
  ipAddresses: 'The IP Address condition has been set. Select an Operator, and choose which IP Lists you want impacted by this policy. You may add additional conditions.',
};

const getConditionStep = key => ([{
  name: 'conditionInfo',
  text: conditionStepText[key],
}]);

const ssoGuides = {
  locations: {
    name: 'locations',
    steps: [
      generalInfoStep,
      applicationAssignmentStep,
      userAssignmentStep,
      ...getConditionStep('locations'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
  devices: {
    name: 'device',
    steps: [
      generalInfoStep,
      applicationAssignmentStep,
      userAssignmentStep,
      ...getConditionStep('device'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
  ipAddresses: {
    name: 'ipAddresses',
    steps: [
      generalInfoStep,
      applicationAssignmentStep,
      userAssignmentStep,
      ...getConditionStep('ipAddresses'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
};

const userPortalGuides = {
  locations: {
    name: 'locations',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      ...getConditionStep('locations'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },

  devices: {
    name: 'device',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      ...getConditionStep('device'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
  ipAddresses: {
    name: 'ipAddresses',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      ...getConditionStep('ipAddresses'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
};

const ldapGuides = {
  locations: {
    name: 'locations',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },

  devices: {
    name: 'device',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },

  ipAddresses: {
    name: 'ipAddresses',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
};

// TODO: Remove 'Legacy' data once conditionalAccessAsideUpdate FF is archived
const conditionStepTextLegacy = {
  device: 'The device condition has been set. Choose whether to apply this policy to JumpCloud managed device or unmanaged devices. You may add additional conditions.',
  locations: 'The location condition has been set. Choose which countries you want impacted by this policy. You may add additional conditions.',
  ipAddresses: 'The IP Address condition has been set. Choose which IP Lists you want impacted by this policy. You may add additional conditions.',
};
const getConditionStepLegacy = key => ([{
  name: 'conditionInfo',
  text: conditionStepTextLegacy[key],
}]);

const ssoGuidesLegacy = {
  locations: {
    name: 'locations',
    steps: [
      generalInfoStep,
      applicationAssignmentStep,
      userAssignmentStep,
      ...getConditionStepLegacy('locations'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
  devices: {
    name: 'device',
    steps: [
      generalInfoStep,
      applicationAssignmentStep,
      userAssignmentStep,
      ...getConditionStepLegacy('device'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
  ipAddresses: {
    name: 'ipAddresses',
    steps: [
      generalInfoStep,
      applicationAssignmentStep,
      userAssignmentStep,
      ...getConditionStepLegacy('ipAddresses'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
};

const userPortalGuidesLegacy = {
  locations: {
    name: 'locations',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      ...getConditionStepLegacy('locations'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },

  devices: {
    name: 'device',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      ...getConditionStepLegacy('device'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
  ipAddresses: {
    name: 'ipAddresses',
    steps: [
      generalInfoStep,
      userAssignmentStep,
      ...getConditionStepLegacy('ipAddresses'),
      actionStep,
      saveStep,
    ],
    currentStep: 0,
  },
};
// End Legacy data

export {
  conditionStepTextLegacy,
  ssoGuides,
  ssoGuidesLegacy,
  userPortalGuides,
  userPortalGuidesLegacy,
  ldapGuides,
};
